import { FC, useMemo } from 'react'
import { Box } from '@mui/material'

// Reuse existing components
import CompactBillDetailsCard from './CompactBillDetailsCard'
import BillPreview from '../../billing/billDetail/BillPreview'

// Types
import { FetchBillDetailsQuery, ExternalUserCaseRole } from '../../../../generated'
import {
  CalculateClientBillDataResult,
  UseFetchBillInterestResult,
  UseFetchOutstandingBillsResult
} from '../../../interfaceTypes'

type BillType = NonNullable<FetchBillDetailsQuery['fetchBillDetails']['bill']>

interface BillPreviewPanelProps {
  bill: BillType | undefined
  selectedClientId: string | undefined
  clientData?: CalculateClientBillDataResult
  interestData?: UseFetchBillInterestResult
  outstandingBillsData?: UseFetchOutstandingBillsResult
}

const BillPreviewPanel: FC<BillPreviewPanelProps> = ({
  bill,
  selectedClientId,
  clientData,
  interestData,
  outstandingBillsData
}) => {
  // const { id, status, amount, amountPaid, dueDate, issueDate, case: caseData } = bill || {}
  const { case: caseData } = bill || {}

  const { caseNumber, title, caseToExternalUserToExternalUserRole, consultMatterNumber } = caseData || {}

  const selectedAccessToken = useMemo(() => {
    return bill?.accessTokens?.find(token => token.client?.id === selectedClientId)
  }, [bill?.accessTokens, selectedClientId])

  if (!bill) return null

  return (
    <Box>
      {/* <CompactBillDetailsCard
        bill={{
          id,
          status,
          amount,
          amountPaid,
          dueDate,
          issueDate,
          case: {
            id: caseData?.id,
            caseNumber: caseNumber || consultMatterNumber,
            title,
            caseToExternalUserToExternalUserRole
          }
        }}
      /> */}

      <BillPreview
        bill={bill}
        client={selectedAccessToken?.client}
        selectedAccessToken={{
          token: selectedAccessToken?.token,
          amount: selectedAccessToken?.amount
        }}
        clientData={clientData}
        interestData={interestData}
        outstandingBillsData={outstandingBillsData}
        isFinalBill={true}
      />
    </Box>
  )
}

export default BillPreviewPanel
